// extracted by mini-css-extract-plugin
export default {"containerGerador":"Gerador_containerGerador__HBCod","load":"Gerador_load__PGw5a","cpfContainer":"Gerador_cpfContainer__knIdw"};